import Vue from 'vue'
import Datepicker from 'vuejs-datepicker'
// import ko from 'vuejs-datepicker/src/locale/translations/ko'

Vue.component('Datepicker', Datepicker)
